import {
  IMMUNOTHERAPY_MODULE,
  PRESCRIPTIONS_MODULE,
  REVIEWED_TESTS_MODULE,
  TESTS_MODULE,
  TEST_ASSIGNMENT_MODULE,
  REVIEWED_IMMUNOTHERAPY_MODULE,
  FERTILITY_CHECK_MODULE,
  REVIEWED_FERTILITY_CHECK_MODULE,
  WEIGHT_LOSS_TREATMENT_CHECK_MODULE,
  REVIEWED_WEIGHT_LOSS_TREATMENT_CHECK_MODULE,
  TREATMENTS_MODULE,
} from './apiUrls';

export const adminRole = [{ action: '*', resource: '*' }];

export const partnerRole = [
  { action: '*', resource: 'dashboard' },
  { action: '*', resource: TEST_ASSIGNMENT_MODULE },
  { action: '*', resource: TESTS_MODULE },
  { action: '*', resource: REVIEWED_TESTS_MODULE },
  { action: '*', resource: IMMUNOTHERAPY_MODULE },
  { action: '*', resource: REVIEWED_IMMUNOTHERAPY_MODULE },
];
export const doctorRole = [
  { action: '*', resource: PRESCRIPTIONS_MODULE },
  { action: '*', resource: TREATMENTS_MODULE },
];

export const pharmacyRole = [
  { action: '*', resource: 'dashboard' },
  { action: '*', resource: TESTS_MODULE },
  { action: '*', resource: REVIEWED_TESTS_MODULE },
];

export const immunotherapyDoctorRole = [
  { action: '*', resource: 'dashboard' },
  { action: '*', resource: IMMUNOTHERAPY_MODULE },
  { action: '*', resource: REVIEWED_IMMUNOTHERAPY_MODULE },
  { action: '*', resource: TREATMENTS_MODULE },
];

export const fertilityDoctorRole = [
  { action: '*', resource: 'dashboard' },
  { action: '*', resource: FERTILITY_CHECK_MODULE },
  { action: '*', resource: REVIEWED_FERTILITY_CHECK_MODULE },
];

export const weightLossDoctorRole = [
  { action: '*', resource: 'dashboard' },
  { action: '*', resource: TEST_ASSIGNMENT_MODULE },
  { action: '*', resource: WEIGHT_LOSS_TREATMENT_CHECK_MODULE },
  { action: '*', resource: REVIEWED_WEIGHT_LOSS_TREATMENT_CHECK_MODULE },
];

export const nutritionistRole = [
  { action: '*', resource: 'dashboard' },
  { action: '*', resource: TREATMENTS_MODULE },
];

export const roles = {
  admin: adminRole,
  partner: partnerRole,
  doctor: doctorRole,
  pharmacy: pharmacyRole,
  immunotherapyDoctor: immunotherapyDoctorRole,
  fertilityDoctor: fertilityDoctorRole,
  weightLossDoctor: weightLossDoctorRole,
  nutritionist: nutritionistRole,
};
